import { AdminStore } from 'stylemix-vue-admin'

export default {
  created() {
    // This hook should only be executed for root component
    if (this.$root !== this) {
      return
    }

    this.$on('account-loaded', account => {
      // For company users get division from account data
      if (account.division && !this.$allows('administer')) {
        this.$store.commit('zones/setCurrentDivision', account.division)
        return
      }

      let currentDivision = localStorage.getItem(`taxi-admin.current-division`)
      if (currentDivision) {
        this.$store.commit(
          'zones/setCurrentDivision',
          JSON.parse(currentDivision),
        )
      }

      const runCountryZonesBootstrap = () => {
        // Zone editor loads divisions with optional ?query= from URL; skip to avoid racing
        // a second unfiltered request that overwrites the filtered list.
        if (this.$route && this.$route.name === 'zones') {
          return
        }
        AdminStore.dispatch('zones/fetchCountryZones').then(result => {
          if (!result || !result.length) {
            return
          }
          if (process.env.VUE_APP_MULTI_DIVISION !== 'true') {
            this.$store.commit('zones/setCurrentDivision', result[0])
            return
          }
          if (!this.$store.state.zones.currentDivision && result[0]) {
            this.$store.commit('zones/setCurrentDivision', result[0])
          }
        })
      }

      if (this.$router) {
        this.$router.onReady(() => {
          this.$nextTick(runCountryZonesBootstrap)
        })
      } else {
        runCountryZonesBootstrap()
      }
    })
  },
}
